import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JsDataService {

  constructor() { }
  public lookupData:any= {};
  public profileData:any= {};
}
